import { gql } from 'apollo-angular';

const GET_DISTRIBUTOR_PRODUCT = gql`
  query GetProduct(
    $productId: Long
    $filterDate: String
    $categorizationSchemeId: Long
    $categoryAttributeTypes: [String]
    $variant: String
  ) {
    purchasedProduct(
      id: $productId
      filterDate: $filterDate
      categorizationSchemeId: $categorizationSchemeId
      categoryAttributeTypes: $categoryAttributeTypes
      variant: $variant
    ) {
      id
      isEditable
      catalogNumber
      manufacturerCatalogNumber
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      description
      brandName
      packageString
      packageTypeOptions
      productPackages {
        unitsInPackage
        packageConversionFactor
        uom
        gtin
      }
      productSource
      spend {
        actualSpend
      }
      statistics {
        crossReferenceStatistic {
          approveCount
          disputeCount
          crossCount
        }
      }
      status
      manufacturer {
        id
        name
      }
      parentManufacturer {
        id
        name
      }
      distributor {
        id
        name
      }
      parentDistributor {
        id
        name
      }
      productAttributes {
        attributes {
          name
          value
        }
        attributeType
      }
      crossReferences {
        id
        marketplaceApproveCount
        marketplaceDisputeCount
        isGPORecommended
        isGPOCross
        sourceTypes
        opinion {
          feedback
          opinion
          parentOpinion
        }
        gpoOpinion {
          feedback
          opinion
          parentOpinion
        }
        notes {
          note
          auditInfo {
            createdBy
            createdDate
            lastModifiedBy
            lastModifiedDate
          }
        }
        gpoNotes {
          note
          auditInfo {
            createdBy
            createdDate
            lastModifiedBy
            lastModifiedDate
          }
        }
        toProduct {
          id
          catalogNumber
          manufacturerCatalogNumber
          packageString
          productSource
          description
          brandName
          status
          category {
            id
            name
          }
          subCategory {
            id
            name
          }
          manufacturer {
            id
            name
          }
          parentManufacturer {
            id
            name
          }
          distributor {
            id
            name
          }
          parentDistributor {
            id
            name
          }
        }
        createdByOrg {
          name
          id
        }
        createdByOrgType
        crossReferenceType
        crossReferenceDescription
      }
    }
  }
`;

export default GET_DISTRIBUTOR_PRODUCT;
